import LogoutIcon from '@mui/icons-material/Logout';
import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MaintenanceModeView } from '../module/maintenance/MaintenanceModeView';

interface Props {
  logout?: () => void;
}

const MaintenancePage: React.FC<Props> = ({ logout }): React.JSX.Element => {
  const { t } = useTranslation('maintenanceModeModule');
  return (
    <MaintenanceModeView
      headlineLarge={t('maintenancePage.headlineLarge')}
      headlineSmall={t('maintenancePage.headlineSmall')}
      message={t('maintenancePage.message')}
    >
      {logout && (
        <Button startIcon={<LogoutIcon />} color="warning" variant="contained" onClick={logout} sx={{ margin: 1 }}>
          {t('errorModule:logout')}
        </Button>
      )}
    </MaintenanceModeView>
  );
};

export default MaintenancePage;
